export enum AffiliateOrganisation {
    FNAC_DARTY_DARTY = "FnacDarty-Darty",
    FNAC_DARTY_OCTOPUS = "FnacDarty-Octopus",
    FNAC_DARTY_ENERCHOICE = "FnacDarty-Enerchoice",
    FNAC_DARTY_JOULERSERVE = "FnacDarty-Jouleserve",
    CREDIT_MUTUEL = "Le Kiosque à Services - Crédit Mutuel",
}
